import { render, staticRenderFns } from "./AlmostDoneCollectConfirmationCard.vue?vue&type=template&id=3c58a10a&scoped=true"
import script from "./AlmostDoneCollectConfirmationCard.vue?vue&type=script&lang=ts"
export * from "./AlmostDoneCollectConfirmationCard.vue?vue&type=script&lang=ts"
import style0 from "./AlmostDoneCollectConfirmationCard.vue?vue&type=style&index=0&id=3c58a10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58a10a",
  null
  
)

export default component.exports